import React, { useState, useEffect } from 'react';
import ChannelListings from './ChannelListings';
import MapView from '../../Shared/Utility/LeafletMap/MapView';
import ToggleViewButton from './ToggleViewButton';
import ChannelFilter from './ChannelFilter';

const ChannelMapOrList = ({ parentChannels, channels, subchannels, handleChooseChannel, isActive, selectedChannel, userId, handleFilter, filter }) => {
  const [filteredChannels, setFilteredChannels] = useState(channels || []);
  const [viewMode, setViewMode] = useState('list');
  const [searchTerm, setSearchTerm] = useState(null);
  const [allChannels] = useState(parentChannels.concat(subchannels));

  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, filter]);
  
  
  
  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setFilteredChannels(channels);
      return;
    }
    
    const lowerQuery = searchTerm.toLowerCase();
    const filtered = channels.filter(channel => 
      channel.title.toLowerCase().includes(lowerQuery)
    );
    
    setFilteredChannels(filtered);
  };

  return (
    <div className="publish-channels-container">
      <p>
        Select a channel below. You must be a member of a department or society in order to contribute to its channel (with the exception of FLAGSHIP).
      </p>

      <ToggleViewButton viewMode={viewMode} setViewMode={setViewMode} />

      {viewMode === 'list' && 
        <>
          <ChannelFilter
            onFilter={handleFilter}
            selectedChannel={selectedChannel}
          />
          <ChannelListings 
            filteredChannels={filteredChannels}
            handleSearch={handleSearch}
            isActive={isActive}
            handleChooseChannel={(channel) => {handleChooseChannel(channel, "list")}}
            selectedChannel={selectedChannel}
          />
        </>
      }

      { viewMode === 'map' && 
        <MapView 
          channels={allChannels}
          selectedChannel={selectedChannel}
          handleChooseChannel={(channel) => {handleChooseChannel(channel, "map")}}
          userId={userId}
          allowSelectingChannel={true}
          height={"600px"}
        />
      }
    </div>
  )
};

export default ChannelMapOrList;